import { useHttpQuery } from '../http/useHttpQuery';

export function useCalculationWithoutManufacturingEnabled() {
    return useHttpQuery('GET /organization-settings/calculation-without-manufacturing', {});
}
